module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <p>Logging you out...</p>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/account/logout/logout.component.html
// module id = ./src/components/account/logout/logout.component.html
// module chunks = main